import I18n from 'i18n'
import { takeLatest, call, put } from 'redux-saga/effects'

import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../actions/externalCourses.action'
import individualExternalCourses from '../../../api/externalCourses/Individual'

async function handleIndividualDownloadExternalCourse(
  externalCourseId: number
) {
  return await individualExternalCourses(externalCourseId)
}

function* externalCoursesDownloadEffectSaga(action: any) {
  try {
    const { data } = yield call(
      handleIndividualDownloadExternalCourse,
      action.payload
    )
    yield put(fromActions.Actions.individualDownloadSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.downSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.downloadError'))
    console.error(error)
  }
}

export function* externalCoursesIndividualDownloadWatcherSaga() {
  yield takeLatest(
    fromActions.EXTERNAL_COURSES_INDIVIDUAL_DOWNLOAD,
    externalCoursesDownloadEffectSaga
  )
}
